import React, { useCallback, useEffect } from 'react';

import { AppletPreviewModalContent, ModalContent, RowButtons } from '../../components';
import Modal from 'components/modal';
import { QuestApplet } from 'models/QuestApplet';
import AppletPreviewSwitch from '../../../../common/applet-preview-switch/index';
import { useDispatch, useSelector } from 'react-redux';
import { selectAchievementByChallenge } from 'modules/profile/selectors';
import { cleanLinkToSharePost, getLinkToShareByChallengePost } from 'modules/loading-screen/contents/actions';
import { SimpleLink, SimpleLinkCopied } from 'modules/challenge/components';
import localizedStrings from 'localization/en';
import useActionStatus from 'hooks/useActionStatus';
import { selectLinkToShare } from 'modules/loading-screen/contents/selectors';
import { ButtonsRow } from 'modules/relationships/components';

type AppletPreviewModalProps = {
  open: boolean;
  applet: QuestApplet;
  closeModal: () => void;
};

const AppletPreviewModal = ({
  open,
  applet,
  closeModal,
}: AppletPreviewModalProps) => {
  const dispatch = useDispatch();
  const [isPendingCopyLink, wasFulfilled] = useActionStatus(getLinkToShareByChallengePost);
  const linkCopied = useSelector(selectLinkToShare)
  const userAchievements = useSelector(selectAchievementByChallenge(applet?.id));

  const renderPreview = useCallback(() => {
    if (applet) {
      const handleGetLink = async () => {
        if (userAchievements) {
          await dispatch(getLinkToShareByChallengePost({
            challengeId: userAchievements.id,
            appletId: applet.id,
          }));
        }
      };
      return <ModalContent>
        <AppletPreviewSwitch applet={applet} />
        {userAchievements ?
          <RowButtons>
            <ButtonsRow>
              {!linkCopied ?
                <SimpleLink onClick={handleGetLink}>
                  {isPendingCopyLink ?
                    `${localizedStrings.copying}...`
                    : localizedStrings.linkToCopy}
                </SimpleLink> :
                <SimpleLinkCopied>
                  {localizedStrings.linkCopied}
                </SimpleLinkCopied>}
            </ButtonsRow>
          </RowButtons>
          : null}
      </ModalContent>;
    }
  }, [applet, dispatch, isPendingCopyLink, linkCopied, userAchievements]);

  const handleClose = () => {
    dispatch(cleanLinkToSharePost());
    closeModal()
  }

  useEffect(() => {
    const copyToClipboard = () => {
      navigator.clipboard.writeText(linkCopied)
        .catch(err => console.error('Error al copiar al portapapeles:', err));
    };

    if (linkCopied && wasFulfilled && !isPendingCopyLink) { copyToClipboard() }
  }, [linkCopied, wasFulfilled, isPendingCopyLink])

  return (
    <Modal open={open} closeModal={handleClose} width="auto">
      <AppletPreviewModalContent>
        {renderPreview()}
      </AppletPreviewModalContent>
    </Modal>
  );
};

export default AppletPreviewModal;
